import { useMutation, useQueryClient } from "@tanstack/react-query";
import { contactApi, contactQueryKeys } from "service/crm/api/contact";

export const useUpdateContactMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: contactApi.updateContact,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: contactQueryKeys.all });
      queryClient.invalidateQueries({
        queryKey: contactQueryKeys.detail(variables.contactUuid),
      });
    },
  });
};

export const useDeleteContactMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (contactUuid: string) => contactApi.deleteContact(contactUuid),
    onSuccess: (_data, contactUuid) => {
      queryClient.invalidateQueries({
        queryKey: contactQueryKeys.all,
        refetchType: "none",
      });
      queryClient.invalidateQueries({ queryKey: contactQueryKeys.lists() });
      queryClient.removeQueries({
        queryKey: contactQueryKeys.detail(contactUuid),
        type: "inactive",
      });
    },
  });
};